/* eslint-disable */
// @ts-nocheck

import { useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { getUsers } from '@/api/usersAPI'
import { createNewVehicle, editNewVehicle } from '@/api/vehiclesAPI'
import Input from '@/components/forms/Input'
import Select from '@/components/forms/Select'
import Button from '@/components/misc/Button'
import { Form } from '@/components/ui/form'
import { User, Vehicle, VehicleType } from '@/interfaces/vehicle'
import useLogisticVehicleForm from '@/state/useLogisticVehicleForm'

import { vehicleTypeOptions } from '../filters/constants/statusOptions'
import { GET_ALL_VEHICLES_QUERY_KEY } from '../hooks/useServerLogisticVehicle'
import { SelectFormUsers } from './SelectFormUsers'
import { Label } from '@/components/ui/label'
import { SelectInterface } from '@/interfaces/InterfacesLocal'
import { useAppSelector } from '@/store/hooks'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'

interface IProp {
  open: boolean
  onOpenChange: () => void
  children?: React.ReactNode

  // close: () => void
  vehicleToEdit?: Vehicle
}
export default function NewVehicleModal({
  open,
  onOpenChange,
  children,
  vehicleToEdit,
}: IProp) {
  const form = useForm()
  const { business } = useAppSelector((state) => state.init)

  const { control, handleSubmit, setError, watch } = form
  const queryClient = useQueryClient()
  const [isSending, setIsSending] = useState(false)
  const { data: containerUsers } = useQuery({
    queryKey: ['users'],
    queryFn: () =>
      getUsers({
        page: 1,
        per_page: 1000,
        search: '',
      }),
  })

  useEffect(() => {
    if (open) {
      if (vehicleToEdit) {
        form.reset({
          vehicle_name: vehicleToEdit.name,
          vehicle_identification: vehicleToEdit.identification,
          vehicle_number: vehicleToEdit.oficialNumber,
          vehicle_type: vehicleToEdit.type,
          vehicle_max_weight: Number(vehicleToEdit.maxWeight),
          vehicle_max_height: Number(vehicleToEdit.maxHeight),
          vehicle_users: vehicleToEdit.operatedBy,
          amount: Number(vehicleToEdit.commission?.amount),
          mode: vehicleToEdit.commission?.mode,
          codeCurrency: vehicleToEdit.commission?.codeCurrency,
        })
      } else {
        form.reset({}) // limpio si es creación
      }
    }
  }, [open, vehicleToEdit])

  const availableCurrencies: SelectInterface[] =
    business?.availableCurrencies.map((item) => ({
      id: item.code,
      name: item.code,
    })) ?? []

  const availableMode = [
    {
      id: 'KILOMETER',
      name: 'Kilómetro',
    },
    {
      id: 'DELIVERY',
      name: 'Entrega',
    },
  ]
  const vehicleName = useLogisticVehicleForm((state) => state.vehicle_name)
  const vehicleIdentification = useLogisticVehicleForm(
    (state) => state.vehicle_identification
  )
  const vehicleNumber = useLogisticVehicleForm((state) => state.vehicle_number)
  const vehicleType = useLogisticVehicleForm((state) => state.vehicle_type)
  const vehicleMaxWeight = useLogisticVehicleForm(
    (state) => state.vehicle_max_weight
  )
  const vehicleMaxHeight = useLogisticVehicleForm(
    (state) => state.vehicle_max_height
  )
  const vehicleAmount = useLogisticVehicleForm((state) => state.amount)
  const vehicleMode = useLogisticVehicleForm((state) => state.mode)
  const vehicleCodeCurrency = useLogisticVehicleForm(
    (state) => state.codeCurrency
  )
  const vehicleUsers = useLogisticVehicleForm((state) => state.vehicle_users)
  const updateVehicleName = useLogisticVehicleForm(
    (state) => state.updateVehicleName
  )
  const updateVehicleIdentification = useLogisticVehicleForm(
    (state) => state.updateVehicleIdentification
  )
  const updateVehicleNumber = useLogisticVehicleForm(
    (state) => state.updateVehicleNumber
  )
  const updateVehicleType = useLogisticVehicleForm(
    (state) => state.updateVehicleType
  )
  const updateVehicleMaxWeight = useLogisticVehicleForm(
    (state) => state.updateVehicleMaxWeight
  )
  const updateVehicleAmount = useLogisticVehicleForm(
    (state) => state.updateVehicleAmount
  )
  const updateVehicleMode = useLogisticVehicleForm(
    (state) => state.updateVehicleMode
  )
  const updateVehicleCodeCurrency = useLogisticVehicleForm(
    (state) => state.updateVehicleCodeCurrency
  )
  const updateVehicleMaxHeight = useLogisticVehicleForm(
    (state) => state.updateVehicleMaxHeight
  )
  const updateVehicleUsers = useLogisticVehicleForm(
    (state) => state.updateVehicleUsers
  )

  useEffect(() => {
    const vehicleName = watch('vehicle_name')
    if (vehicleName) updateVehicleName(vehicleName)
  }, [watch('vehicle_name')])

  useEffect(() => {
    const vehicleId = watch('vehicle_identification')
    if (vehicleId) updateVehicleIdentification(vehicleId)
  }, [watch('vehicle_identification')])

  useEffect(() => {
    const vehicleNumber = watch('vehicle_number')
    if (vehicleNumber) updateVehicleNumber(vehicleNumber)
  }, [watch('vehicle_number')])

  useEffect(() => {
    const vehicleType = watch('vehicle_type')
    if (vehicleType) updateVehicleType(vehicleType)
  }, [watch('vehicle_type')])

  useEffect(() => {
    const maxWeight = watch('vehicle_max_weight')
    if (maxWeight) updateVehicleMaxWeight(maxWeight)
  }, [watch('vehicle_max_weight')])

  useEffect(() => {
    const maxHeight = watch('vehicle_max_height')
    if (maxHeight) updateVehicleMaxHeight(maxHeight)
  }, [watch('vehicle_max_height')])
  useEffect(() => {
    const amount = watch('amount')
    if (amount) updateVehicleAmount(amount)
  }, [watch('amount')])
  useEffect(() => {
    const mode = watch('mode')
    if (mode) updateVehicleMode(mode)
  }, [watch('mode')])
  useEffect(() => {
    const codeCurrency = watch('codeCurrency')
    if (codeCurrency) updateVehicleCodeCurrency(codeCurrency)
  }, [watch('codeCurrency')])

  useEffect(() => {
    const vehicleUsers = watch('vehicle_users')
    if (vehicleUsers) updateVehicleUsers(vehicleUsers)
  }, [watch('vehicle_users')])

  const createVehicle = useMutation({
    mutationFn: createNewVehicle,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ALL_VEHICLES_QUERY_KEY],
      })
      setIsSending(false)
      onOpenChange()
      toast.success('El vehículo ha sido creado con éxito.')
    },
    onError: (response: { response?: { statusText?: string } }) => {
      setIsSending(false)
      // onOpenChange()
      toast.error(
        JSON.stringify(
          response.response?.statusText ||
            'Lo siento, ha ocurrido un error intentando crear el vehículo'
        )
      )
    },
  })

  const editVehicle = useMutation({
    mutationFn: editNewVehicle,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ALL_VEHICLES_QUERY_KEY],
      })
      setIsSending(false)
      onOpenChange()
      toast.success('El vehículo ha sido editado con éxito.')
    },
    onError: (response: { response?: { statusText?: string } }) => {
      setIsSending(false)
      // onOpenChange()
      toast.error(
        JSON.stringify(
          response.response?.statusText ||
            'Lo siento, ha ocurrido un error intentando editar el vehículo'
        )
      )
    },
  })

  const onSubmit: SubmitHandler<
    Record<string, string | number | boolean | string[] | User>
  > = (data) => {
    if (!data.vehicle_name.trim()) {
      setError(
        'vehicle_name',
        {
          type: 'manual',
          message: '¡Este campo es requerido!',
        },
        { shouldFocus: true }
      )
      return
    }

    const maxLength = 255
    const value = data.vehicle_identification.trim()
    if (!value) {
      setError(
        'vehicle_identification',
        {
          type: 'manual',
          message: '¡Este campo es requerido!',
        },
        { shouldFocus: true }
      )
      return
    }

    if (value.length > maxLength) {
      setError(
        'vehicle_identification',
        {
          type: 'manual',
          message: `¡No puede exceder ${maxLength} caracteres!`,
        },
        { shouldFocus: true }
      )
      return
    }
    if (!data.vehicle_type) {
      setError(
        'vehicle_type',
        {
          type: 'manual',
          message: '¡Este campo es requerido!',
        },
        { shouldFocus: true }
      )
      return
    }
    if (!data.vehicle_max_weight) {
      setError(
        'vehicle_max_weight',
        {
          type: 'manual',
          message: '¡Este campo es requerido!',
        },
        { shouldFocus: true }
      )
      return
    }
    if (!data.vehicle_max_height) {
      setError(
        'vehicle_max_height',
        {
          type: 'manual',
          message: '¡Este campo es requerido!',
        },
        { shouldFocus: true }
      )
      return
    }
    if (data.vehicle_users.id === 0) {
      setError(
        'vehicle_users',
        {
          type: 'manual',
          message: '¡Este campo es requerido!',
        },
        { shouldFocus: true }
      )
      return
    }
    if (!data.amount) {
      setError(
        'amount',
        {
          type: 'manual',
          message: '¡Este campo es requerido!',
        },
        { shouldFocus: true }
      )
      return
    }
    if (!data.mode) {
      setError(
        'mode',
        {
          type: 'manual',
          message: '¡Este campo es requerido!',
        },
        { shouldFocus: true }
      )
      return
    }
    if (!data.codeCurrency) {
      setError(
        'codeCurrency',
        {
          type: 'manual',
          message: '¡Este campo es requerido!',
        },
        { shouldFocus: true }
      )
      return
    }

    setIsSending(true)
    if (vehicleToEdit) {
      editVehicle.mutate({
        id: vehicleToEdit.id,
        name: data.vehicle_name as string,
        identification: data.vehicle_identification as string,
        oficialNumber: data.vehicle_number as string,
        type: data.vehicle_type as VehicleType,
        maxWeight: data.vehicle_max_weight as number,
        maxHeight: data.vehicle_max_height as number,
        operatedById: (data.vehicle_users as User)?.id as number,
        commission: {
          amount: data.amount,
          mode: data.mode,
          codeCurrency: data.codeCurrency,
        },
      })
    } else {
      createVehicle.mutate({
        name: data.vehicle_name as string,
        identification: data.vehicle_identification as string,
        oficialNumber: data.vehicle_number as string,
        type: data.vehicle_type as VehicleType,
        maxWeight: data.vehicle_max_weight as number,
        maxHeight: data.vehicle_max_height as number,
        operatedById: (data.vehicle_users as User)?.id as number,
        commission: {
          amount: data.amount,
          mode: data.mode,
          codeCurrency: data.codeCurrency,
        },
      })
    }
  }

  const title = vehicleToEdit ? 'Editar vehículo' : 'Nuevo vehículo'
  const amountValue = watch('amount')

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      {children && <DialogTrigger asChild>{children}</DialogTrigger>}
      <DialogContent className="flex max-h-[90vh] flex-col overflow-visible sm:max-w-2xl md:max-w-3xl lg:max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-xl md:text-2xl">{title}</DialogTitle>
        </DialogHeader>

        <div className="flex-grow space-y-6 overflow-y-auto px-4 py-8 sm:px-6">
          <div>
            <Form {...form}>
              <div className="pb-3">
                <Input
                  control={control}
                  defaultValue={
                    vehicleToEdit ? vehicleToEdit?.name : vehicleName
                  }
                  label={'Nombre (*)'}
                  name={'vehicle_name'}
                  placeholder={'Nombre...'}
                />
              </div>
              <div className="flex justify-between pb-5">
                <div className="w-64">
                  <Input
                    control={control}
                    defaultValue={
                      vehicleToEdit
                        ? vehicleToEdit?.identification
                        : vehicleIdentification
                    }
                    label={'Identificación (*)'}
                    name={'vehicle_identification'}
                    placeholder={'Identificación...'}
                  />
                </div>
                <div className="ml-2 w-64">
                  <Input
                    control={control}
                    defaultValue={
                      vehicleToEdit
                        ? vehicleToEdit?.oficialNumber
                        : vehicleNumber
                    }
                    label={'Número oficial (*)'}
                    name={'vehicle_number'}
                    placeholder={'Número oficial...'}
                  />
                </div>
              </div>
              <div className="pb-2">
                <Select
                  control={control}
                  data={vehicleTypeOptions
                    .map((status) => ({
                      id: status.value,
                      name: status.label,
                    }))
                    .filter((item) => item.name !== 'Todos')}
                  defaultValue={
                    vehicleToEdit ? vehicleToEdit?.type : vehicleType
                  }
                  label={'Tipo (*)'}
                  name={'vehicle_type'}
                  placeholder={'Seleccione...'}
                />
              </div>
              <div className="flex justify-between pb-2">
                <div className="flex w-64 items-center gap-2">
                  <Input
                    allowComma
                    control={control}
                    defaultValue={
                      vehicleToEdit
                        ? vehicleToEdit?.maxWeight
                        : vehicleMaxWeight
                    }
                    label="Peso máximo (*)"
                    name="vehicle_max_weight"
                    placeholder="Peso máximo..."
                    type="number"
                  />
                  <Label
                    className="mt-4 flex items-center whitespace-nowrap"
                    htmlFor="vehicle_max_weight"
                  >
                    kg
                  </Label>
                </div>
                <div className="ml-2 flex w-64 items-center gap-2">
                  <Input
                    allowComma
                    control={control}
                    defaultValue={
                      vehicleToEdit
                        ? vehicleToEdit?.maxHeight
                        : vehicleMaxHeight
                    }
                    label={'Altura máxima (*)'}
                    name={'vehicle_max_height'}
                    placeholder={'Altura máxima...'}
                    type="number"
                  />
                  <Label
                    className="mt-4 flex items-center whitespace-nowrap"
                    htmlFor="vehicle_max_height"
                  >
                    m
                  </Label>
                </div>
              </div>
              <div className="pb-2">
                <Label>Operado por (*)</Label>
                <SelectFormUsers
                  control={control}
                  data={
                    containerUsers
                      ?.filter((user) =>
                        user.roles?.some(
                          (role) => role.code === 'MANAGER_SHIPPING'
                        )
                      )
                      .map(({ id, displayName, email }) => ({
                        id,
                        title: displayName,
                        subtitle: email,
                      })) ?? []
                  }
                  defaultValue={
                    vehicleToEdit ? vehicleToEdit?.operatedBy : vehicleUsers
                  }
                  // label={'Operado por'}
                  name={'vehicle_users'}
                />
              </div>

              <div className="top-0 z-10 bg-white pb-2 pt-2">
                <h4 className="text-md mb-3 border-t pt-4 font-medium">
                  Implementar pago de comisión fija por mensajería
                </h4>
              </div>

              <div className="flex items-end gap-2">
                <div className="flex-1">
                  <Input
                    allowComma
                    defaultValue={
                      vehicleToEdit && vehicleToEdit.commission
                        ? Number(vehicleToEdit?.commission?.amount)
                        : vehicleAmount
                    }
                    label="Monto (*)"
                    name="amount"
                    placeholder="Monto..."
                    type="number"
                  />
                </div>
                <div className="w-40">
                  <Select
                    control={control}
                    data={availableMode}
                    disabled={!amountValue}
                    defaultValue={
                      vehicleToEdit
                        ? vehicleToEdit?.commission?.mode
                        : vehicleMode
                    }
                    label="Por (*)"
                    name="mode"
                  />
                </div>
                <div className="w-40">
                  <Select
                    control={control}
                    data={availableCurrencies}
                    disabled={!amountValue}
                    defaultValue={
                      vehicleToEdit
                        ? vehicleToEdit?.commission?.codeCurrency
                        : vehicleCodeCurrency
                    }
                    label="Moneda (*)"
                    name="codeCurrency"
                  />
                </div>
              </div>
            </Form>
          </div>
        </div>

        <DialogFooter className="flex flex-col-reverse gap-2 border-t px-4 pt-4 sm:flex-row sm:justify-end sm:px-6">
          {/* <Button onClick={() => onOpenChange()} variant="outline">
            Cancelar
          </Button> */}
          <Button
            action={handleSubmit(onSubmit)}
            disabled={isSending}
            loading={isSending}
            name={isSending ? 'Guardando...' : 'Guardar'}
          ></Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
